import { render, staticRenderFns } from "./NeedHelpDialog.vue?vue&type=template&id=7d2cb78a"
import script from "./NeedHelpDialog.vue?vue&type=script&lang=js"
export * from "./NeedHelpDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports